import { SET_ACTIVE_SPECIALTY } from './SpecialtyTypes';
import { SPECIALTY_IDS } from 'config/specialtyConfig';
import { SUBJECTS_UNITS_RESET } from 'redux/QuestionBank/SubjectsUnitsTypes';
import { QUESTIONS_RESET } from 'redux/QuestionBank/QuestionsTypes';
import { FEEDBACK_RESET } from 'redux/QuestionBank/FeedbackTypes';
import { RESET_EXAM_STATE } from 'redux/QuestionBank/FullLengthExamTypes';
import { RESET_TEST_PROGRESS } from 'redux/QuestionBank/TestProgressTypes';
import { CLEAR_ADMIN_ANALYTICS } from 'redux/QuestionBank/AdminAnalyticsTypes';
import { FETCH_TPC_COURSES_RESET } from 'redux/ManageTpcCourses/ManageTpcCoursesTypes';

/**
 * Switch the active specialty.
 * Persists to localStorage, resets all question-bank reducers so stale data
 * from the previous specialty doesn't bleed through, then sets the new value.
 */
export const switchSpecialty = (specialtyId) => {
  return (dispatch, getState) => {
    if (!SPECIALTY_IDS.includes(specialtyId)) return;

    const current = getState().specialty.activeSpecialty;
    if (current === specialtyId) return;

    // Persist
    try {
      localStorage.setItem('activeSpecialty', specialtyId);
    } catch (e) {
      // localStorage unavailable
    }

    // Reset question-bank and video-course reducers so data refetches from the new specialty's collections
    dispatch({ type: SUBJECTS_UNITS_RESET });
    dispatch({ type: QUESTIONS_RESET });
    dispatch({ type: FEEDBACK_RESET });
    dispatch({ type: RESET_EXAM_STATE });
    dispatch({ type: RESET_TEST_PROGRESS });
    dispatch({ type: CLEAR_ADMIN_ANALYTICS });
    dispatch({ type: FETCH_TPC_COURSES_RESET });

    // Set new specialty
    dispatch({ type: SET_ACTIVE_SPECIALTY, payload: specialtyId });
  };
};
